import { useEffect } from "react";
import { AttributeType } from "@evergis/api";
import { UpdateAttribute } from "../../../../../hooks/attributes/useAttributes";
import { LayerAttribute } from "../../../EditResource/components/Layer/LayerAttributeItem";
import { defaultValue, dateOptions, timeOptions } from "../AttributeFormat/FormatSettingsOptions";
import { FormStateType, PointFormState, DateFormState, NumberFormState } from "./useAttributeFormat";

// eslint-disable-next-line @typescript-eslint/quotes, quotes
export const TIME_ZONE_FORMAT = ' "GMT"z';
export const RU_LOCALE = "ru-RU";
export const EN_LOCALE = "en-US";

const defaultDateSettings = {
  format: dateOptions[1].value,
  culture: RU_LOCALE,
};

export const updatePointFormat = (formState: PointFormState) => {
  if (formState.format === defaultValue) return null;

  const mantissa = "D";
  const format = formState.format === "DD." ? formState.format + mantissa.repeat(formState.rounding) : formState.format;

  return {
    format,
  };
};

export const updateDateFormat = (formState: DateFormState) => {
  if (!formState.format) return defaultDateSettings;

  const currentFormat = formState.showTime
    ? `${formState.format} ${formState.timeFormat ? formState.timeFormat : timeOptions[0].value}`
    : formState.format;

  return {
    format: formState.showTimeZone ? currentFormat + TIME_ZONE_FORMAT : currentFormat,
    culture: currentFormat.includes("tt") ? EN_LOCALE : RU_LOCALE,
  };
};

export const updateNumberFormat = (formState: NumberFormState) => ({
  scalingFactor: formState.format ? +formState.format : 1,
  unitsLabel: formState.label,
  splitDigitGroup: formState.splitDigitGroup,
  rounding: formState.rounding || 0,
  culture: RU_LOCALE,
});

export const useUpdateAttributeFormat = (
  type: AttributeType,
  id: string,
  formState: FormStateType,
  updateAttribute: UpdateAttribute<LayerAttribute>,
) => {
  useEffect(() => {
    let stringFormat = null;

    switch (type) {
      case AttributeType.Point:
        stringFormat = updatePointFormat(formState);
        break;
      case AttributeType.DateTime:
        stringFormat = updateDateFormat(formState);
        break;
      case AttributeType.Double:
      case AttributeType.Int32:
      case AttributeType.Int64:
        stringFormat = updateNumberFormat(formState);
        break;
      default:
        return;
    }

    updateAttribute(id, {
      stringFormat,
    });
  }, [type, formState, updateAttribute, id]);
};
